<template>
  <div class="menu-component" @click="onClick">
    <div class="icon-str">
      <div class="left">menu</div>
      <div class="right">●</div>
    </div>
  </div>
</template>

<script>
import LOGO_SIDE from '../assets/logo/logo-side.svg';
import AGENT_SVGS from '../assets/images/agents/index.js';
import CONSTANS from '@/constants/index.js';
import BUTTON_SVGS from '../assets/images/buttons/index.js';

export default {
  props: {
    gainValue: String,
  },
  methods: {
    onClick() {
      this.$emit('menuClick');
    },
  },
  computed: {
    _logoSrc() {
      return LOGO_SIDE;
    },
    _agentSvgs() {
      return AGENT_SVGS;
    },
    _buttonSvgs() {
      return BUTTON_SVGS;
    },
    _population() {
      return CONSTANS.TYPE_MAP;
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-component {
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  padding-left: 20px;
  height: 100%;
  width: 30px;
  z-index: 1;

  &:hover {
    .left {
      &::after {
        width: 42px;
      }
    }
  }
}

.icon-str {
  color: rgb(7, 7, 81);
  display: flex;
  transform: rotate(90deg);
  align-items: center;
  margin: 10px 0 0 5px;
  transform-origin: left;
}

.left {
  font-size: 15px;
  font-weight: 300;
  width: 42px;

  &::after {
    content: '';
    display: block;
    width: 0px;
    height: 1px;
    background-color: rgb(7, 7, 81);
    transition: width 0.1s cubic-bezier(0.32, 0.625, 0.58, 1);

    position: absolute;
    bottom: -1px;
    left: 0;
  }
}

.right {
  margin: 2px 0 0 8px;
}
</style>
